import { stdObject } from "../../../../data/types/stdObject";
import { colors } from "../../../../data/colors";
import { sendData } from "../../../../services/sendData";

export const openInventory = async (
  id: string,
  cDate: string,
  params: stdObject,
) => {
  const {
    t,
    user,
    setWindowValues,
    setModalData,
    setMsg,
    setMsg2,
    closeMsg,
    logoutAction,
  } = params;
  setMsg2("loading");
  const responseInventory: stdObject =
    id === ""
      ? {
          success: true,
          status: true,
          info: {
            CODINV: id,
            ALMINV: user.ALMSUC,
            COLINV: 0,
            FECINV: cDate,
            OBSINV: "",
          },
        }
      : await sendData({
          endPoint: "callInventory",
          payload: { id },
          logoutAction,
        });

  console.log("responseInventory: ", responseInventory);
  const { success, status } = responseInventory;
  if (success && status) {
    closeMsg(2);
    setMsg("inventoryModal");
    setModalData({
      id: responseInventory.info.CODINV,
      title: id === "" ? t("p.newINV") : responseInventory.info.NOMART,
      mainColor: colors.items,
      inputs: [
        {
          code: "FECINV",
          label: t("c.FEC"),
          type: "datetime-local",
        },
        {
          code: "ARTINV",
          label: t("c.ART"),
          searchType: "ART",
          type: id === "" ? "innerButton" : "info",
        },
        {
          code: "COLINV",
          label: t("c.COL"),
          type: id === "" ? "select" : "info",
          options: [],
        },
        {
          code: "ALMINV",
          label: t("c.ALM"),
          type: "info",
        },
        {
          code: "ACTINV",
          label: t("p.current"),
          type: "integer",
          innerStyle: { width: 100, textAlign: "right" },
        },
        {
          code: "DISINV",
          label: t("p.available"),
          type: "integer",
          innerStyle: { width: 100, textAlign: "right" },
        },
        {
          code: "OBSINV",
          label: t("c.OBS"),
          type: "text",
        },
      ],
    });

    const itemData =
      id === ""
        ? ["", ""]
        : [responseInventory.info.ARTINV, responseInventory.info.NOMART];

    setWindowValues({
      FECINV: responseInventory.info.FECINV,
      ARTINV: itemData,
      COLINV: responseInventory.info.COLINV,
      ALMINV: responseInventory.info.ALMINV,
      ACTINV: responseInventory.info.ACTINV,
      DISINV: responseInventory.info.DISINV,
      OBSINV: responseInventory.info.OBSINV,
    });
  } else {
    setMsg2("error");
  }
};
